import { Editor, ReactEditor, Transforms } from '@lumapps/wrex/slate';

import { T_D, T_H } from '../constants';
import type { TableEditor, TDElement, THElement } from '../types';
import { getCurrentCellsInRow } from './getCurrentCellsInRow';
import { getCurrentSelectionInfos } from './getCurrentSelectionInfos';
import { isTableHeaderCell } from './isTableHeaderCell';
import { setBoldOnCells } from './setBoldOnCells';

/**
 * Toggle the header state of the first row of the table containing the current selection.
 * Enabling converts every first-row cell into a `th` column header (`scope="col"`) and bolds its
 * text; disabling converts them back into plain `td` cells and removes that bold.
 */
export const toggleHeaderRow = (editor: ReactEditor & TableEditor) => {
    const selectionInfos = getCurrentSelectionInfos(editor);

    if (!selectionInfos) {
        return;
    }

    const { tablePath } = selectionInfos;
    const { cellsInRow } = getCurrentCellsInRow(editor, [...tablePath, 0]);
    const shouldBeHeader = !isTableHeaderCell(cellsInRow[0]?.[0]);

    Editor.withoutNormalizing(editor, () => {
        cellsInRow.forEach(([, cellPath]) => {
            if (shouldBeHeader) {
                Transforms.setNodes<THElement>(editor, { type: T_H, headerType: 'col' }, { at: cellPath });
            } else {
                Transforms.setNodes<TDElement>(editor, { type: T_D }, { at: cellPath });
                Transforms.unsetNodes(editor, 'headerType', { at: cellPath });
            }
        });
        setBoldOnCells(
            editor,
            cellsInRow.map(([, cellPath]) => cellPath),
            shouldBeHeader,
        );
    });
};
